import Input from '../Input/Input';
import '../../../styles/Form.css';
import { FormProps } from './Form.types';
import Button from '../../../components/designSystem/Button/Button';
import { Controller } from 'react-hook-form';
import Select from '../Select/Select';
import { SelectOption } from '../Select/Select.types';
import { ButtonColor, ButtonSize } from '../../../components/designSystem/Button/Button.types';
import RegisterStepButton from '../RegisterStepButton/RegisterStepButton';
import { InputProps } from '../Input/Input.types';
import TextArea from '../TextArea/TextArea';
import { TextAreaProps } from '../TextArea/TextArea.types';
import { useCallback } from 'react';
import SearchInput from '../SearchInput/SearchInput';

export const Form = <TSchema,>({
  data,
  formProps,
  onSubmit,
  hideButton,
  buttonLabel,
  isCompany,
  afterInputsElement,
  isRegisterStep,
  className,
  ...props
}: FormProps<TSchema>) => {
  const {
    control,
    formState: { isValid, errors },
  } = formProps;

  const CurrentInput = useCallback((props: InputProps | TextAreaProps) => {
    if ((props as InputProps).type === 'textarea') {
      return <TextArea {...(props as TextAreaProps)} />;
    } else if ((props as InputProps).name === 'address') {
      // @ts-ignore
      return <SearchInput {...(props as TextAreaProps)} />;
    } else {
      return <Input {...(props as InputProps)} />;
    }
  }, []);

  return (
    <form {...props} className={`form ${className || ''}`}>
      <div className="form__container">
        {data.map((row, rowIndex) => (
          <div key={rowIndex} className="form__row">
            {row.map(
              (
                { name, placeholder, label, type, options, onChangeValue, ...props },
                inputIndex
              ) => (
                <Controller
                  key={inputIndex}
                  name={name as string}
                  render={({ field: { onChange, value, ...rest } }) =>
                    type !== 'select' ? (
                      <CurrentInput
                        name={name as string}
                        placeholder={placeholder || ''}
                        type={type}
                        error={errors[name]?.message as string}
                        onChange={(e: any) => {
                          const value = e.target.value;
                          onChange(e);
                          if (onChangeValue) {
                            onChangeValue(value);
                          }
                        }}
                        {...{ value, label, isCompany }}
                        {...props}
                      />
                    ) : (
                      <Select
                        placeholder={placeholder || ''}
                        error={errors[name]?.message as string}
                        {...{ label, options, isCompany, ...rest }}
                        {...props}
                        // @ts-ignore
                        onChange={({ value }: SelectOption) => {
                          onChange(value);
                          if (onChangeValue) {
                            onChangeValue(value);
                          }
                        }}
                      />
                    )
                  }
                  {...{ control }}
                />
              )
            )}
          </div>
        ))}
        {afterInputsElement && <div className="form__after-inputs">{afterInputsElement}</div>}
        {isRegisterStep && <RegisterStepButton {...{ isCompany }} />}
        {!hideButton && (
          <Button
            style={{ alignSelf: 'unset' }}
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            size={ButtonSize.Large}
            disabled={!isValid}
            color={isCompany ? ButtonColor.Secondary : ButtonColor.Primary}>
            {buttonLabel || 'Valider'}
          </Button>
        )}
      </div>
      {/* {!hideButton &&
        <Button
          style={{ alignSelf: 'flex-end' }}
          onClick={(e) => {
            e.preventDefault()
            onSubmit()
          }}
          size={ButtonSize.Large}
          disabled={!isValid}
        >
          {buttonLabel || "Valider"}
        </Button>
      } */}
      {/* <br /> */}
    </form>
  );
};

export default Form;
